<!--
 * @Author: your name
 * @Date: 2021-09-20 10:09:13
 * @LastEditTime: 2021-12-26 16:37:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\createTask\createTask.vue
-->
<template>
  <div>
    <bounty-back :title="$t('Project.MyProject')" @goBack="goBack"></bounty-back>
    <div class="create-task">
      <!-- <img  src="../../../../assets/My/project.png" alt=""> -->
      <svg v-if="false" class="project-left-img" width="615" height="732" viewBox="0 0 615 732" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f)">
        <circle cx="248.5" cy="248.5" r="168.5" fill="#6448D4" fill-opacity="0.16"/>
        </g>
        <g filter="url(#filter1_f)">
        <circle cx="368" cy="552" r="146" fill="#49E3F8" fill-opacity="0.05"/>
        </g>
        <rect x="63" y="138" width="253" height="296" rx="24" fill="#1C1C20"/>
        <path d="M187 218C187 204.745 197.745 194 211 194H365V627H211C197.745 627 187 616.255 187 603V218Z" fill="white"/>
        <path d="M365 194L513 194C526.255 194 537 204.745 537 218V603C537 616.255 526.255 627 513 627H365V194Z" fill="url(#paint0_linear)"/>
        <path opacity="0.18" d="M365 236H493C499.627 236 505 241.373 505 248V333C505 339.627 499.627 345 493 345H365V236Z" fill="url(#paint1_linear)"/>
        <path opacity="0.16" d="M216 248C216 241.373 221.373 236 228 236H365V345H228C221.373 345 216 339.627 216 333V248Z" fill="url(#paint2_linear)"/>
        <rect opacity="0.16" x="215" y="371" width="72" height="54" rx="8" fill="url(#paint3_linear)"/>
        <rect x="237" y="271" width="77" height="18" rx="9" fill="white"/>
        <rect x="237" y="299" width="48" height="17" rx="8.5" fill="url(#paint4_linear)"/>
        <rect x="215" y="552" width="48" height="17" rx="8.5" fill="url(#paint5_linear)"/>
        <rect opacity="0.2" x="215" y="526" width="72" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect opacity="0.2" x="215" y="512" width="72" height="8" rx="4" fill="#BBBBBB"/>
        <rect opacity="0.2" x="215" y="434" width="72" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect opacity="0.2" x="215" y="491" width="48" height="8" rx="4" fill="#BBBBBB"/>
        <rect opacity="0.2" x="215" y="449" width="48" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect opacity="0.2" x="92" y="175" width="72" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect opacity="0.2" x="92" y="190" width="48" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect x="92" y="359" width="72" height="9" rx="4.5" fill="white"/>
        <rect opacity="0.2" x="92" y="382" width="48" height="9" rx="4.5" fill="#BBBBBB"/>
        <rect opacity="0.2" x="92" y="336" width="48" height="9" rx="4.5" fill="#BBBBBB"/>
        <path opacity="0.2" d="M389 495H440" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <path d="M520 654H412" stroke="white" stroke-opacity="0.1" stroke-width="8" stroke-linecap="round"/>
        <path d="M452 681H588" stroke="white" stroke-opacity="0.1" stroke-width="8" stroke-linecap="round"/>
        <path opacity="0.2" d="M389 520H479" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <path opacity="0.2" d="M389 545H497" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <path opacity="0.2" d="M389 295H440" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <path opacity="0.2" d="M389 320H479" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <rect x="142" y="584" width="90" height="91" rx="12" fill="#18D6BE"/>
        <rect x="164.321" y="628.826" width="13.5094" height="26.3141" rx="4" transform="rotate(-45 164.321 628.826)" fill="white"/>
        <rect x="201.18" y="610.027" width="13.5094" height="39.3905" rx="4" transform="rotate(45 201.18 610.027)" fill="white"/>
        <circle cx="400" cy="268" r="12" fill="url(#paint6_linear)"/>
        <circle cx="108" cy="305" r="16" fill="url(#paint7_linear)"/>
        <path d="M368 624V198" stroke="#EFE2FE" stroke-width="7" stroke-linecap="square"/>
        <circle opacity="0.1" cx="529" cy="185" r="86" fill="url(#paint8_linear)"/>
        <circle cx="529" cy="185" r="54.8406" fill="url(#paint9_linear)"/>
        <path d="M507.812 204.942V195.094L538.515 163.812L548.942 173.66L517.66 204.942H507.812Z" stroke="white" stroke-width="4" stroke-linecap="square"/>
        <path d="M137.875 463.121L94.125 483.433H117.562V506.871L137.875 463.121Z" fill="white"/>
        <defs>
        <filter id="filter0_f" x="0" y="0" width="497" height="497" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur"/>
        </filter>
        <filter id="filter1_f" x="188" y="372" width="360" height="360" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="17" result="effect1_foregroundBlur"/>
        </filter>
        <linearGradient id="paint0_linear" x1="365" y1="194" x2="547.637" y2="198.534" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF" stop-opacity="0.33"/>
        <stop offset="1" stop-color="#18D6BE" stop-opacity="0.28"/>
        </linearGradient>
        <linearGradient id="paint1_linear" x1="365" y1="236" x2="512.798" y2="247.864" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint2_linear" x1="216" y1="236" x2="373.165" y2="249.428" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint3_linear" x1="215" y1="371" x2="290.972" y2="377.331" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint4_linear" x1="237" y1="299" x2="286.46" y2="307.728" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint5_linear" x1="215" y1="552" x2="264.46" y2="560.728" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint6_linear" x1="388" y1="256" x2="413.401" y2="257.588" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint7_linear" x1="92" y1="289" x2="127.122" y2="292.902" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint8_linear" x1="443" y1="99" x2="625.039" y2="110.377" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        <linearGradient id="paint9_linear" x1="474.159" y1="130.159" x2="590.242" y2="137.415" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A737FF"/>
        <stop offset="1" stop-color="#18D6BE"/>
        </linearGradient>
        </defs>
      </svg>
      <div class="right-box">
        <div class="my-title">{{$t('Project.CreateProject')}}</div>
        <el-form ref="form" id="form_my" :label-position="'top'" class="form_wrap">
            <el-form-item class="required" :label="$t('Project.ProjectName')">
              <el-input maxlength="100" v-model="formData.ProjectName"></el-input>
            </el-form-item>
            <el-form-item class="required" :label="$t('Project.ProjectType')">
              <el-select class="w-240" v-model="formData.ProjectType" style="width: 100%">
                <el-option v-for="(item,index) in projectTypeList" :key="index + '_' + item" :label="item.name_en" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="required" :label="$t('Project.ProjectDescription')">
              <el-input maxlength="500" type="textarea" :autosize="{minRows:4}" v-model="formData.ProjectDescription"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Project.ProjectURL')">
              <el-input maxlength="100" v-model="formData.ProjectURL"></el-input>
            </el-form-item>
            <el-form-item class="logo-upload required" :label="$t('Project.LOGOUpload')">
              <el-upload
                class="avatar-uploader img_upload"
                :action="action"
                :headers="headerObj"
                :name="'mFile'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleError"
                :before-upload="beforeAvatarUploadImage">
                <img v-if="formData.imageUrl" :src="formData.imageUrl" class="avatar">
                <svg v-else width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30 10.0007V50.0007" stroke="#4C4C55" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M50 30.0007H10" stroke="#4C4C55" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </el-upload>
            </el-form-item>
            <div v-if="!isView" class="saveBtn cancelselect" @click="saveProject">{{$t('Project.Confirm')}}</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveProject, selectDictByParentCode } from '@/api/bounty.js'
import { eventBus } from '@/plugin/eventBus/index.js'

export default {
  name: 'createTask',
  data () {
    return {
      uploadLoading: '',
      action: baseUrl + '/bounty/files/uploadFile',
      headerObj: {
        token: sessionStorage.getItem('bountyToken'),
        walletAddress: sessionStorage.getItem('walletAddress')
      },
      formData: {
        ProjectName: '',
        ProjectType: '',
        ProjectDescription: '',
        ProjectURL: '',
        imageUrl: ''
      },
      projectTypeList: [],
      select1: ''
    }
  },
  props: ['DATA', 'isEdit', 'isView'],
  mounted () {
    // 查询项目类型字典
    // createTime: "2012-09-09"
    // id: '1'
    // projectDesc: '123'
    // projectIcon: 'http://bountyv2.oss-cn-hongkong.aliyuncs.com/bounty2/image%5C1444117279213228032.png'
    // projectName: 'projectname'
    // projectType: 'nft'
    // console.log(this.DATA, 'this.DATA')
    eventBus.$on('createProjectDictChange', () => {
      this.getDict()
    })
    if (this.DATA && this.DATA.id) {
      this.formData.id = this.DATA.id
      this.formData.ProjectName = this.DATA.projectName
      this.formData.ProjectType = this.DATA.projectType
      this.formData.ProjectURL = this.DATA.ProjectURL
      this.formData.imageUrl = this.DATA.projectIcon
      this.formData.ProjectDescription = this.DATA.projectDesc
    }
    this.getDict()
    // selectDictByParentCode({ parentCode: 'bty_plan_status' }).then(res => {
    //   if (!res.code) {
    //     if (res.data.dict.length) {
    //       // this.projectTypeList = res.data.dict
    //       console.log(res.data.dict)
    //     }
    //   }
    // }).catch(err => {
    //   console.log(err)
    // })
  },
  methods: {
    /**
     * @description: 获取字典
     * @param {*}
     * @return {*}
     */
    getDict () {
      selectDictByParentCode({ parentCode: 'bty_project_type' }).then(res => {
        if (!res.code) {
          if (res.data.dict.length) {
            if (localStorage.getItem('languageBounty') === 'cn') {
              res.data.dict = res.data.dict.map(item => {
                item.name_en = item.name
                return item
              })
            }
            this.projectTypeList = res.data.dict
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * @description: 返回我的页面
     * @param {*}
     * @return {*}
     */
    goBack () {
      this.$emit('backMy')
    },
    /**
     * @description: 上传失败
     * @param {*}
     * @return {*}
     */
    handleError () {
      this.uploadLoading.close()
    },
    /**
     * @description: 文件上传成功
     * @param {*} res
     * @param {*} file
     * @return {*}
     */
    handleAvatarSuccess (res, file) {
      this.formData.imageUrl = file.response.data.url
      this.handleError()
    },
    /**
     * @description: 文件上传前校验
     * @param {*} file
     * @return {*}
     */
    beforeAvatarUploadImage (file) {
      const isJPG = file.type === 'image/jpeg'
      const isBMP = file.type === 'image/bmp'
      const isPNG = file.type === 'image/png'

      if (!isJPG && !isBMP && !isPNG) {
        this.$message.error(this.$t('allTip.tip6'))
      } else {
        this.uploadLoading = this.$loading({ lock: true, text: this.$t('My.loading'), spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      }
      return isJPG || isBMP || isPNG
    },
    /**
     * @description: 保存项目
     * @param {*}
     * @return {*}
     */
    saveProject () {
      if (!this.formData.ProjectName) {
        return this.$message({
          type: 'warning',
          offset: '120',
          message: this.$t('allTip.tip8')
        })
      }
      if (!this.formData.ProjectType) {
        return this.$message({
          type: 'warning',
          offset: '120',
          message: this.$t('allTip.tip9')
        })
      }
      if (!this.formData.ProjectDescription) {
        return this.$message({
          type: 'warning',
          offset: '120',
          message: this.$t('allTip.tip10')
        })
      }
      if (!this.formData.imageUrl) {
        return this.$message({
          type: 'warning',
          offset: '120',
          message: this.$t('allTip.tip11')
        })
      }
      const params = {
        entryName: this.formData.ProjectName,
        projectType: this.formData.ProjectType,
        projectWebsite: this.formData.ProjectURL,
        logo: this.formData.imageUrl,
        remarks: this.formData.ProjectDescription
      }
      if (this.DATA.id) {
        params.id = this.DATA.id
      }
      saveProject(params).then(res => {
        if (!res.code) {
          this.$message({
            type: 'success',
            offset: 120,
            message: 'success'
          })
          this.$emit('backMy')
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style>
.create-task .logo-upload .el-form-item__content{
  width: 160px;
}
</style>
<style lang="scss" scoped>
.create-task{
  // display: flex;
  // padding-left: 35px;
  // padding-right: 55px;
  // justify-content: space-between;
  .project-left-img{
    width: 615px;
    height: 732px;
    margin-top: 6px;
    margin-left: -100px;
  }
  .right-box{
    // width: 41.7%;
  }
}
.saveBtn{
  margin-top: 54px !important;
}
.my-title{
  margin-top: 0px !important;
}
.el-date-editor{
  width: 100%;
}
</style>
